import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Input, Grid, Dropdown, Form, TextArea } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';
import Server from '../../../functions/server';

export default class JobCard extends React.Component {

    state = {
        values: {}, data: [], operatorDetails: [], OperatorOptions: [], addition: 1, 
        machineServiceOption: [], serviceOption: []
    }

    componentDidMount() {
        let data = (ReadCookie("branch"));
        let branch_id = 0;
        for (var i = 0; i < data.length; i++) {
            branch_id = data[i].branch_id;
        }
        this.setState({ branch_id })
    }

    getCustomerAndLabor = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Customer And Labor Details', })
        $.ajax({
            type: 'POST', url: Server() + 'Sales/JobCard/GetCustomerAndLabor.php',
            success: function (data) {
                try {
                    data = JSON.parse(data);
                    let OperatorOptions = [];
                    data.map((c) => {
                        if (c.type == "Operator") {
                            OperatorOptions.push({ key: c.id+"->"+c.name+"->"+c.mobile, text: c.id+"->"+c.name+"->"+c.mobile, value: Number(c.id) })
                        }
                    })
                    if (context.props.item) {
                        let item = context.props.item;
                        item["edate"] = item.expected_date;
                        context.setState({ dialog: true, values: item, data, load: false, OperatorOptions })
                    }
                    else {
                        context.setState({ dialog: true, values: {}, data, load: false, OperatorOptions })
                    }
                } catch (error) {
                    context.setState({ load: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    addOperatorArray = () => {
        let operatorDetails = this.state.operatorDetails;
        let id = 0;
        operatorDetails.map((c) => {
            id = c.id;
        })
        id = id + 1;
        operatorDetails.push({ id })
        this.setState({ operatorDetails })
    }

    handleChange1 = (type, id) => event => {
        let operatorDetails = this.state.operatorDetails;
        operatorDetails.map((c) => {
            if (c.id == id) {
                if (type == 'name') {
                    c.name = event.target.value;
                }
                if (type == 'address') {
                    c.address = event.target.value;
                }
                if (type == 'mobile') {
                    c.mobile = event.target.value;
                }
            }
        })
        this.setState({ operatorDetails })
    }

    handleChange = name => event => {
        this.setState({
            values: {
            ...this.state.values,
            [name]: event.target.value,
            },
        });
    };

    makeCustomerDropdownOption = () => {
        let data = this.state.data;
        let option = [];
        data.map((c) => {
            if (c.type == "Customer") {
                option.push({ key: c.id+"->"+c.name+"->"+c.mobile+"->"+c.taluk, text: c.id+"->"+c.name+"->"+c.mobile+"->"+c.taluk, value: c.id })
            }
        })
        return option;
    }

    makeMachineDropdown = (type) => {
        let data = this.state.data;
        let option = []; 
        data.map((c) => {
            if (c.type == "Machine") {
                option.push({ key: c.id+"->"+c.name, text: c.id+"->"+c.name, value: c.name })
            }
        })
        return option;
    }

    submit = () => {
        let context = this;
        context.setState({ load: true, message: 'Add Job Master Details', })
        let values = this.state.values;
        values["branch_id"] = this.state.branch_id;
        values["operatorDetails"] = JSON.stringify(this.state.operatorDetails);
        $.ajax({
            type: 'POST', data: values, url: Server() + 'Sales/JobCard/AddMaster.php',
            success: function (data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ load: false, values: {}, dialog: false })
                    context.props.refresh();
                }
                else {
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    selectMode = (f, { value }) => {
        this.setState({
            values: {
            ...this.state.values,
            "mode": value,
            },
        });
    }

    selectMachineService = (f, { value }) => {
        let machine = value.split('->')[0];
        this.setState({
            values: {
                ...this.state.values,
                "machineserviceoption": value,
                "machine": machine
            }
        })
        let serviceType = value.split('->')[3];
        let masterid = value.split('->')[4];
        let machineno = value.split('->')[5];
        this.getFreeServices(serviceType, masterid, machineno);
    }

    getFreeServices = (serviceType, masterid, machineno) => {
        let context = this;
        let values = this.state.values;
        $.ajax({
            type: 'POST', data: { 'id': serviceType, 'cid': values.cid, masterid, machineno },
            url: Server()+'machine/ServiceType/GetCustomerFreeService.php',
            success: function(data) {
                console.log(data);
                console.log('datatatat');
                try {
                    data = JSON.parse(data);
                    let serviceOption = [];
                    data.map((c) => {
                        serviceOption.push({ text: c.name, key: c.name, value: c.id+"->"+c.mid })
                    })
                    context.setState({ load: false, ViewService: true, serviceOption })
                } catch (error) {
                    alert('Try Agian!!!');
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    selectMachine = (f, { value }) => {
        this.setState({
            values: {
                ...this.state.values,
                "machine": value
            }
        })
    }

    selectCustomer = (f, { value }) => {
        this.setState({
            values: {
                ...this.state.values,
                "cid": value
            }
        })
        this.getCustomerFreeServiceHistory(value);
    }

    selectService = (f, { value }) => {
        this.setState({
            values: {
                ...this.state.values,
                "service": value.split("->")[0],
                "servicemid": value.split("->")[1],
                "servicedropdown": value,
            }
        })
    }


    getCustomerFreeServiceHistory = (cid) => {
        let context = this;
        $.ajax({
            type: 'POST', data: { cid }, url: Server() + 'machinecustomer/GetCustomerFreeService.php',
            success: function (data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    console.log(data);
                    let machineServiceOption = [];
                    data.map((c) => {
                        machineServiceOption.push({ 
                            key: c.machinename+"->"+c.servicetype+"->"+c.machine_no, 
                            text: c.machinename+"->"+c.servicetype+"->"+c.machine_no, 
                            value: c.machinename+"->"+c.servicetype+"->"+c.machineid+"->"+c.servicetypeid+"->"+c.masterid+"->"+c.machine_no
                        })
                    })
                    context.setState({ load: false, machineServiceOption, service: data })
                } catch (error) {
                    alert('Error');
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }


    handleAddition = (value, id) => {
        let { addition, OperatorOptions, operatorDetails } = this.state;
        OperatorOptions.push({ key: addition+"->"+value, text: addition+"->"+value, value: 'I'+addition }) 
        operatorDetails.map((c) => {
            if (c.id == id) {
                c.name = value;
                c.address = "";
                c.mobile = "";
                c.oid = 'I'+addition;
            }
        })
        addition = addition + 1;
        this.setState({ OperatorOptions, addition, operatorDetails })
    }

    changeOperator = (value, id) =>{
        let { data, operatorDetails } = this.state;
        data.map((c) => {
            if (c.id == value && c.type == "Operator") {
                operatorDetails.map((v) => {
                    if (v.id == id) {
                        v.name = c.name;
                        v.address = c.taluk;
                        v.mobile = c.mobile;
                        v.oid = value;
                    }
                })
            }
        })
        this.setState({ operatorDetails })
    }

    deleteOperator = (id) => {
        let { operatorDetails } = this.state;
        let newoperatorDetails = [];
        operatorDetails.map((c) => {
            if (c.id != id) {
                newoperatorDetails.push(c);
            }
        })
        let i = 0;
        newoperatorDetails.map((c) => { c.id = i + 1; })
        this.setState({ operatorDetails: newoperatorDetails })
    }

    

    render() {
        let { load, serviceOption, operatorDetails, dialog, values, OperatorOptions, machineServiceOption } = this.state;
        let { item } = this.props;
        let customerOption = this.makeCustomerDropdownOption();
        let machineOption = this.makeMachineDropdown();

        let i = 1;

        let modeOption = [
            { text: 'Minor', key: 'Minor', value: 'Minor' },
            { text: 'Semi Major', key: 'Semi Major', value: 'Semi Major' },
            { text: 'Major', key: 'Major', value: 'Major' },
            { text: 'Free Service', key: 'Free Service', value: 'Free Service' },
            { text: 'Warrenty Service', key: 'Warrenty Service', value: 'Warrenty Service' },
            { text: 'Other', key: 'Other', value: 'Other' }
        ]

        return (
            <div>
                { item ?
                    <div style={{cursor: 'pointer'}} onClick={this.getCustomerAndLabor}>Edit</div>
                    :
                    <Button onClick={this.getCustomerAndLabor}>Add Job Master</Button>
                }
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"Job Card Master"} </DialogTitle>
                    <DialogContent>
                        <Grid>
                            { values.id ? null :
                                <Grid.Column mobile={16} tablet={16} computer={6}>
                                    <b>Select Customer</b>
                                    <Dropdown fluid search onChange={this.selectCustomer} selection 
                                        options={customerOption} value={values.cid} />
                                </Grid.Column>
                            }
                            
                            <Grid.Column mobile={16} tablet={16} computer={6}>
                                <b>Work Type</b><br/>
                                <Dropdown fluid search onChange={this.selectMode} selection 
                                    options={modeOption} value={values.mode} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={4}>
                                <b>Expected Out Date</b><br/>
                                <input type="date" id="date" value={values.edate}
                                onChange={this.handleChange('edate')} style={{width: '100%', height: 35 }} />
                            </Grid.Column>

                            { values.mode == 'Free Service' ?
                                (
                                    <Grid.Column mobile={16} tablet={16} computer={16}>
                                        <Grid>
                                            <Grid.Column mobile={16} tablet={16} computer={6}>
                                                <b>Select Machine</b>
                                                <Dropdown fluid search onChange={this.selectMachineService} 
                                                    selection  options={machineServiceOption} 
                                                    value={values.machineserviceoption} />
                                            </Grid.Column>
                                            <Grid.Column mobile={16} tablet={16} computer={5}>
                                                <b>Running Hours</b><br/>
                                                <Input type={'number'} fluid 
                                                placeholder='Running Hours' value={values.killometer} 
                                                onChange={this.handleChange('killometer')} />
                                            </Grid.Column>
                                            <Grid.Column mobile={16} tablet={16} computer={5}>
                                                <b>Refrence Number</b><br/>
                                                <Input fluid 
                                                placeholder='Refrence Number' value={values.refrenceno} 
                                                onChange={this.handleChange('refrenceno')} />
                                            </Grid.Column> 
                                            <Grid.Column mobile={16} tablet={16} computer={16}>
                                                <b>Select Service</b>
                                                <Dropdown fluid search onChange={this.selectService} 
                                                    selection  options={serviceOption} 
                                                    value={values.servicedropdown} />
                                            </Grid.Column>
                                        </Grid>
                                    </Grid.Column>
                                ) :
                                (
                                    <Grid.Column mobile={16} tablet={16} computer={5}>
                                        <b>Select Machine</b>
                                        <Dropdown fluid search onChange={this.selectMachine} selection 
                                            options={machineOption} value={values.machine} />
                                    </Grid.Column>
                                )
                            }
                            


                            <Grid.Column mobile={16} tablet={16} computer={16}>
                                <b>Problem</b>
                                <Form>
                                    <TextArea fluid placeholder='Tell us more' onChange={this.handleChange('issue')} value={values.issue}  />
                                </Form>
                            </Grid.Column>
                            { values.id ? 
                                null :
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                    <b>Operator Details</b>
                                    <table width="100%" id="table">
                                        <tr>
                                            <th id='tableheader' style={{width: '5%'}}><center>Sino</center></th>
                                            <th id='tableheader' style={{width: '30%'}}><center>Operator Name</center></th>
                                            <th id='tableheader' style={{width: '40%'}}><center>Address</center></th>
                                            <th id='tableheader' style={{width: '15%'}}><center>Mobile</center></th>
                                            <th id='tableheader' style={{width: '10%'}}><center>Action</center></th>
                                        </tr>

                                        { 
                                            operatorDetails.map((c) => {
                                                return (
                                                <tr>
                                                        <td>{i++}</td>
                                                        <td>
                                                            <Dropdown
                                                                options={OperatorOptions}
                                                                placeholder='Operator Name'
                                                                search
                                                                selection
                                                                fluid
                                                                allowAdditions
                                                                value={c.oid}
                                                                onAddItem={ (e, { value }) => this.handleAddition(value, c.id)}
                                                                onChange={ (e, { value }) => this.changeOperator(value, c.id)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Input disabled={ typeof c.oid == 'number' ? true : false } fluid placeholder='Operator Address' value={c.address} 
                                                                onChange={this.handleChange1('address', c.id)} />
                                                        </td>
                                                        <td>
                                                            <Input disabled={ typeof c.oid == 'number' ? true : false } fluid placeholder='Operator Mobile' value={c.mobile} 
                                                                onChange={this.handleChange1('mobile', c.id)} />
                                                        </td>
                                                        <td><center onClick={ () => this.deleteOperator(c.id)}>Delete</center></td>
                                                </tr> 
                                                )
                                            })

                                        }
                                    </table>
                                    <center><Button onClick={this.addOperatorArray}>Add Operator</Button></center>
                                </Grid.Column>
                            }
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                        <Button onClick={this.submit}>Submit</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}